"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Graphql = void 0;
const __1 = require("..");
const Graphql = event => {
    if (event.http) {
        const httpRequest = event.http;
        if (httpRequest.method === 'GET') {
            const url = new URL(httpRequest.url);
            event.graphql = mapGraphqlData({
                operationName: url.searchParams.get('operationName'),
                query: url.searchParams.get('query'),
                variables: (0, __1.safeParseJson)(url.searchParams.get('variables')).value,
            });
        }
        if (httpRequest.method === 'POST' &&
            httpRequest.requestBody &&
            httpRequest.requestHeaders['content-type'] === 'application/json') {
            const json = (0, __1.safeParseJson)(httpRequest.requestBody);
            if (json.value) {
                event.graphql = mapGraphqlData(json.value);
            }
        }
    }
    return event;
};
exports.Graphql = Graphql;
function mapGraphqlData({ operationName, query, variables, }) {
    const matcher = /^(mutation|query)?(\s*)?([a-zA-Z]*)?(\s*)?(\(.*\))?(\s*)?{/g;
    const match = query && matcher.exec(query.trim());
    if (match) {
        return {
            operationType: (match[1] || 'query'),
            operationName: operationName || undefined,
            query,
            variables: variables || undefined,
        };
    }
}
